<sesio-chart kind="highstock" [options]="options" (ready)="loadData($event)">
</sesio-chart>
